import { createContext, useEffect, useReducer } from "react";
const AuthContext = createContext();
const actionReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
      };
    case "LOGOUT":
      return {
        ...state,
        user: null,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

const AuthContextProvider = ({ children }) => {
  const [userState, dispatcher] = useReducer(actionReducer, {
    user: null,
    isAuthenticated: false,
    setOpen: false,
  });

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      dispatcher({
        type: "LOGIN",
        payload: JSON.parse(user),
      });
    }
  }, []);
  return (
    <AuthContext.Provider value={{ ...userState, dispatcher }}>
      {children}
    </AuthContext.Provider>
  );
};
export { AuthContext, AuthContextProvider };
